import { Chip } from "@mui/material";
import { useIntl } from "react-intl";
import { SettingListItem } from "services/KnowfullyAdminClient";

const styles = {
  overriddenChip: {
    color: "text.secondary",
    borderColor: "divider",
    textTransform: "uppercase",
  },
};

type InheritedFromCellProps = {
  value: SettingListItem;
};

export default function InheritedFromCell({ value }: InheritedFromCellProps) {
  const { formatMessage: t } = useIntl();

  // An overridden setting resolves from this organization, so its own name carries no information.
  if (value.isOverridden) {
    return (
      <Chip
        label={t({ id: "settingInheritanceOverridden" })}
        variant="outlined"
        size="small"
        sx={styles.overriddenChip}
      />
    );
  }

  return <>{value.inheritedOrganizationName}</>;
}
